import styled from "styled-components";
import { useSelector } from 'react-redux';
import { Topbar } from "../Components/Topbar"
import { Sidebar } from "../Components/Sidebar"
import Navigator from "../Components/Navigator"
import Addassets from '../Components/Assets/AssetManager/Addassets/Addassets';
import Assetmaster from '../Components/Masters/Assetmaster/Assetmaster';
import Myassets from '../Components/Assets/Myasset/Myassets';
import Assetanalytics from '../Components/Assets/Assetanalytics';
import Assetapprove from '../Components/Assets/AssetManager/Assetapprove/Assetapprove'
import Dashboard from '../Components/Assets/Dashboards/Dashboard';
import Assethome from '../Components/Assets/Assetshome';
import Management from '../Components/Management';
import Assetreport from '../Components/Assets/Assetreport';
import Assettransaction from '../Components/Assets/AssetTransactions/Assettransaction';
import Assetforms from '../Components/Assets/Assetforms/Assetforms';
import HomeCom from "../Components/Homecomp";
import AllOffices from "../Components/Masters/Offices/Offices";
import OfficeType from "../Components/Masters/OfficeType/OfficeType";
import Users from "../Components/Users/Users";
import MyUsers from "../Components/Users/MyUsers";
import EditUsers from "../Components/Users/EditUsers";
import AssetMan from '../Components/Assets/AssetManager/AssetMan';
import AddUsers from "../Components/Users/AddUsers";
import ApproveUsers from '../Components/Users/ApproveUsers';
import AssetDistribute from '../Components/Assets/AssetManager/AssetDistribute/AssetDistribute';
import MyRequests from '../Components/Assets/Myrequests/MyRequests';
import RequestMaster from '../Components/Masters/RequestMaster/RequestMaster';
import IssueReq from '../Components/Assets/Myrequests/IssueReq/IssueReq';
import Inbox from '../Components/Assets/Myrequests/Inbox/Inbox';
import Sent from '../Components/Assets/Myrequests/Outbox/Sent';
import Complaints from '../Components/Complaints/Complaints';
import ComplaintMaster from '../Components/Masters/Complaintmaster/Complaintmaster'
import RegisterComplaint from '../Components/Complaints/RegisterComplaint';
import SupportUsers from '../Components/Supportusers/SupportUsers';
import AddSupportUsers from '../Components/Supportusers/AddSupportUsers';
import AllSupportUsers from '../Components/Supportusers/AllSupportUsers';
import StoreOffices from '../Components/Masters/Storeoffices/AllStoreOffices';
import Designations from '../Components/Masters/Designations/Designations';
import DesignationSuffix from '../Components/Masters/DesignationSuffix/DesignationSuffix';
import ReAssignComplaint from '../Components/Supportusers/ReAssignComplaint';
import OffToOffReq from '../Components/Assets/Bo/OffToOffReq';
import OffAssetTransReq from '../Components/Assets/Bo/OffAssetTransReq'
import AMinbox from '../Components/Assets/AssetManager/Inbox/AMinbox'
import AMSent from '../Components/Assets/AssetManager/Outbox/AMSent'
import StoreToStorReq from '../Components/Assets/AssetManager/StoreToStoreReq'
import StoreAssetTransReq from '../Components/Assets/AssetManager/StoreAssetTransReq';
import Unithead from '../Components/Assets/Unithead/Unithead';
import OffAssetHandoverReq from '../Components/Assets/Bo/OffAssetHandoverReq'
import EmailMaster from '../Components/Masters/Emailmaster/EmailMaster'
import Masterdata from '../Components/Masters/MasterData';
import ChangeOfficeReq from '../Components/Users/changeOfficeReq/ChangeOfficeReq';
import UserChanges from '../Components/Users/UserChanges';
import AssetSurrender from '../Components/Assets/AssetManager/AssetSurrender/AssetSurrender'
import { Routes, Route } from "react-router-dom";
import flatten from '../data/flattenarray';
import addpath from '../data/addpath';
import useAuth from '../features/hooks/useAuth';
import filtereddata from '../data/filterUI';
import BrandMaster from '../Components/Masters/Brandmaster/BrandMaster';
import VendorMaster from '../Components/Masters/Vendormaster/VendorMaster';
import Notifications from '../Components/Notifications/MyNotifications';
import AddBulkUsers from '../Components/Users/AddBulkUsers';
import ModelnoMaster from '../Components/Masters/Modelno/Modelno';
import AppIndividualAssets  from '../Components/Masters/AppIndividualAssets/AppIndividualAssets';
import Test from '../Components/Masters/Test/Test';
import ConsumablesMaster from '../Components/Masters/Consumablesmaster/ConsumMasterHome'
import AllComplaints from '../Components/Complaints/AllComplaints';
import ComplaintsSup from '../Components/Supportusers/AssignedComplaints/ComplaintsSup';
import EditSupportUsers from '../Components/Supportusers/EditSupportUsers';
import Consumables from '../Components/Consumables/ConsumableHome';
import ConsumMan from '../Components/Consumables/ConsumMan/ConsumMan';
import AddConsumables from '../Components/Consumables/ConsumMan/AddConsumables/AddConsumables';
import MyConsumables from '../Components/Consumables/MyConsumables/MyConsumables';
import ConsumableApprove from '../Components/Consumables/ConsumMan/ApproveConsum/ConsumableApprove';
import DistributeConsum from '../Components/Consumables/ConsumMan/DistributeConsum/DistributeConsum';
import Correction from '../Components/Correction/Correction';
import AssetTags from '../Components/Correction/AssetTags/AssetTags'
import ClosedReq from '../Components/Assets/Myrequests/ClosedReq/ClosedReq'
import SurrenderConsum from '../Components/Consumables/ConsumMan/SurrenderConsum/SurrenderConsum';
import FinalPdfForms from '../Components/FinalPdfForms/FinalPDFForms';
import SurveyReport from '../Components/Assets/AssetManager/SurveyReport/SurveyReport';
import ViewSurveyAssets from '../Components/Assets/AssetManager/SurveyReport/ViewSurveyAssets/ViewSurveyAssets';
import SurveyAssets from '../Components/Assets/AssetManager/SurveyReport/SurveyAssets/SurveyAssets';
import UpdateBulkUsers from '../Components/Users/UpdateBulkUsers';
import UnifiedInbox from '../Components/Inbox/UnifiedInbox';
import UnifiedSentbox from '../Components/Sentbox/UnifiedSentbox';
import UserAssetReturnReq from '../Components/Assets/Myrequests/UserAssetReturnReq/UserAssetReturnReq'
import BoAssetReturnReq from '../Components/Assets/Myrequests/BoAssetReturnReq/BoAssetReturnReq';
import ConsumablesReq from '../Components/Consumables/ConsumablesReq/ConsumablesReq';
import ConsumIssueReq from '../Components/Consumables/ConsumablesReq/ConsumIssueReq/ConsumIssueReq';
import BoToStoreConsumReq from '../Components/Consumables/ConsumablesReq/BoToStoreConsumReq/BoToStoreConsumReq';
import LoginSessions from '../Components/MyProfile/LoginSessions/LoginSessions';
import EditPassword from '../Components/MyProfile/EditPassword/EditPassword';
import MyProfile from '../Components/MyProfile/MyProfile';
import ViewProfile from '../Components/MyProfile/ViewProfile/ViewProfile';
import SystemLogs from '../Components/SystemLogs/SystemLogs';
import UserActivityLogs from '../Components/SystemLogs/UserActivityLogs';
import OfficeConsum from '../Components/Consumables/OfficeConsum/OfficeConsum';
import ConsumTransac from '../Components/Consumables/ConsumTransac/ConsumTransac';


const Pagelist = {
  Dashboard: <Dashboard />,
  Management: <Management />,
  Assetshome: <Assethome />,
  Myassets: <Myassets />,
  Addassets: <Addassets />,
  Assetmaster: <Assetmaster />,
  Assetanalytics: <Assetanalytics />,
  Assetreport: <Assetreport />,
  Assettransaction: <Assettransaction />,
  Assetapprove: <Assetapprove />,
  Assetforms: <Assetforms />,
  HomeCom: <HomeCom />,
  // SubCategMaster: <SubCategMaster />,
  AllOffices: <AllOffices />,
  OfficeType: <OfficeType />,
  Users: <Users />,
  AddUsers: <AddUsers />,
  MyUsers: <MyUsers />,
  EditUsers: <EditUsers />,
  ApproveUsers: <ApproveUsers />,
  AssetDistribute: <AssetDistribute />,
  IssueReq: <IssueReq />,
  Inbox: <Inbox />,
  Sent: <Sent />,
  ComplaintMaster: <ComplaintMaster />,
  RegisterComplaint: <RegisterComplaint />,
  SupportUsers: <SupportUsers />,
  AddSupportUsers: <AddSupportUsers />,
  ReAssignComplaint: <ReAssignComplaint />,
  AllSupportUsers: <AllSupportUsers />,
  StoreOffices: <StoreOffices />,
  Designations: <Designations />,
  DesignationSuffix: <DesignationSuffix />,
  OffAssetTransReq: <OffAssetTransReq />,
  OffToOffReq: <OffToOffReq />,
  AMinbox: <AMinbox />,
  AMSent: <AMSent />,
  StoreAssetTransReq: <StoreAssetTransReq />,
  StoreToStoreReq: <StoreToStorReq />,
  OffAssetHandoverReq: <OffAssetHandoverReq />,
  EmailMaster: <EmailMaster />,
  Masterdata: <Masterdata />,
  Complaints: <Complaints />,
  MyRequests: <MyRequests />,
  RequestMaster:<RequestMaster />,
  AssetMan: <AssetMan />,
  Unithead: <Unithead />,
  AssetSurrender:<AssetSurrender/>,
  ChangeOfficeReq:<ChangeOfficeReq/>,
  UserChanges:<UserChanges/>,
  BrandMaster:<BrandMaster/>,
  Notifications:<Notifications/>,
  AddBulkUsers:<AddBulkUsers/>,
  ModelnoMaster:<ModelnoMaster/>,
  AppIndividualAssets:<AppIndividualAssets/>,
  Test: <Test/>,
  VendorMaster:<VendorMaster/>,
  ConsumablesMaster:<ConsumablesMaster/>,
  AllComplaints:<AllComplaints/>,
  ComplaintsSup:<ComplaintsSup/>,
  EditSupportUsers:<EditSupportUsers/>,
  Consumables:<Consumables/>,
  ConsumMan:<ConsumMan/>,
  AddConsumables:<AddConsumables/>,
  MyConsumables:<MyConsumables/>,
  ConsumableApprove:<ConsumableApprove/>,
  DistributeConsum:<DistributeConsum/>,
  Correction:<Correction/>,
  AssetTags:<AssetTags/>,
  ClosedReq: <ClosedReq/>,
  SurrenderConsum:<SurrenderConsum/>,
  FinalPdfForms: <FinalPdfForms/>,
  SurveyReport: <SurveyReport/>,
  ViewSurveyAssets: <ViewSurveyAssets/>,
  SurveyAssets: <SurveyAssets/>,
  UpdateBulkUsers: <UpdateBulkUsers/>,
  UnifiedInbox: <UnifiedInbox/>,
  UnifiedSentbox: <UnifiedSentbox/>,
  UserAssetReturnReq: <UserAssetReturnReq/>,
  BoAssetReturnReq: <BoAssetReturnReq/>,
  ConsumablesReq: <ConsumablesReq/>,
  ConsumIssueReq: <ConsumIssueReq/>,
  BoToStoreConsumReq: <BoToStoreConsumReq/>,
  EditPassword: <EditPassword/>,
  LoginSessions: <LoginSessions/>,
  MyProfile: <MyProfile/>,
  ViewProfile: <ViewProfile/>,
  SystemLogs: <SystemLogs/>,
  UserActivityLogs: <UserActivityLogs/>,
  OfficeConsum:<OfficeConsum/>,
  ConsumTransac:<ConsumTransac/>
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding:0;
    height: 100%;
    width: 100%;
`
const LowerContainer = styled.div`
    display: flex;
    height: calc(100vh - 71px);  
    margin-top: 2px;
    overflow: hidden;
`
const OtherPages = styled.div`
    margin-left: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex:1;
    overflow-y: auto;
    overflow-x: auto;
    background-color: #edeff6;
`

const Home = () => {
  const Auth = useAuth();
  
  const currentOffice = useSelector((state) => state.office.off)

  const flatarray = flatten(addpath(filtereddata(Auth, currentOffice)));
  console.log(flatarray)

  return (
    <>
      <Container>
        <Topbar />
        <LowerContainer>
          <Sidebar />
          <OtherPages>
            <Navigator />
            <Routes>
              <Route index element={<HomeCom />} />
              {flatarray.map((item, index) => {
                return (
                  <Route key={index} path={item.path} element={Pagelist[item.page]} />
                );
              })}
            </Routes>
          </OtherPages>
        </LowerContainer>
        {/* <Footer/> */}
      </Container>
    </>
  )

}

export default Home;